<template>
    <v-autocomplete
      v-if="items"
      :items="items"
      item-text="name"
      item-value="id"
      v-model="model"
      :label="label"
      :disabled="disabled"
    ></v-autocomplete>
  </template>
  
  <script>
import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        model: this.value,
        items: null
      };
    },
    props: {
      value: {
        type: Number
      },
      label: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      value() {
        this.model = this.value;
      },
      model() {
        this.$emit("input", this.model);
      }
    },
    mounted () {
        this.loadCurrencies()
            .then(({currencies}) => {
                this.items = currencies
            })
    },
    methods: {
        ...mapActions('bexio', ['loadCurrencies'])
    }
  };
  </script>
  
  <style>
  </style>